import React from "react";
import styles from "../styles/rightsListHeader.module.css";
import plus from "../assets/images/plus.png";

const RightsListHeader = ({ title, categoryCount, addFunction }) => {
  const addNewItem = () => {
    addFunction();
  };

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <p className={styles.categoryTitle}>{title}</p>
      </div>
      <div className={styles.buttonsContainer}>
        <div className={styles.addButton} onClick={addNewItem}>
          <div className={styles.plusIconContainer}>
            <img src={plus} alt="Plus Icon" className={styles.plusIcon} />
          </div>
        </div>
        <div className={styles.counterContainer}>
          <p className={styles.counterText}>{categoryCount}</p>
        </div>
      </div>
    </div>
  );
};

export default RightsListHeader;
